<style lang="scss" scoped>
.workshopHourOuput::-webkit-scrollbar {
  display: none;
}

.grid {
  &:not(:last-child) {
    margin-right: 10px;
  }
}
</style>
<style lang="scss" scoped>
.weier-prodcution-monitor-border {

  border: 1px solid;
  border-image: url("../../../../../../assets/img/web/weier/production/xiankuang2.png") 10 stretch;
}
</style>

<template>
  <div class="workshopHourOuput" ref="container" style="overflow: auto;height: 100%;position: relative;display: flex;flex-direction: column;">
    <div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;padding-bottom: 0px;box-sizing: border-box;">
      <img style="width: auto;height: 42px;" src="../../../../../../assets/img/web/weier/production/bzry.png" />
    </div>
    <div class="weier-prodcution-monitor-border" style="padding: 10px;flex: 1;display: flex;flex-direction: column;justify-content: space-between;">

      <div style="flex: 1;display: flex;justify-content: space-between;">
        <div class="grid" style="flex:1;display: flex;align-items: center;justify-content: space-around;">
          <img src="../../../../../../assets/img/web/weier/production/chejian.png" style="width: 30px;height: auto;">
          <P style="color: white;font-weight: bold;font-size: 20px;"> {{ datas.firstFloorWorkshopName }}</P>
          <div style="text-align: center;">
            <p style="font-size: 14px;color:#C0C4CC;margin-bottom: 10px;">注塑操作员</p>
            <p style="font-size: 18px;color:white;font-weight: bold;">{{ datas.firstFloorEmployeeCount }} 人</p>
          </div>
          <div style="text-align: center">
            <p style="font-size: 14px;color:#C0C4CC;margin-bottom: 10px;">间接人员</p>
            <p style="font-size: 18px;color:white;font-weight: bold;">{{ datas.firstFloorSubordinateCount }} 人</p>
          </div>
        </div>
      </div>

      <div style="flex: 1;display: flex;justify-content: space-between;">
        <div class="grid" style="flex:1;display: flex;align-items: center;justify-content: space-around;">
          <img src="../../../../../../assets/img/web/weier/production/chejian.png" style="width: 30px;height: auto;">
          <P style="color: white;font-weight: bold;font-size: 20px;"> {{ datas.secondFloorWorkshopName }}</P>
          <div style="text-align: center;">
            <p style="font-size: 14px;color:#C0C4CC;margin-bottom: 10px;">注塑操作员</p>
            <p style="font-size: 18px;color:white;font-weight: bold;">{{ datas.secondFloorEmployeeCount }} 人</p>
          </div>
          <div style="text-align: center">
            <p style="font-size: 14px;color:#C0C4CC;margin-bottom: 10px;">间接人员</p>
            <p style="font-size: 18px;color:white;font-weight: bold;">{{ datas.secondFloorSubordinateCount }} 人</p>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_customize_weier_monitor_production_banci",
  components: {},
  props: {
    datas: {
      type: Object,
      default: function () {
        return {};
      }
    },
  },
  data() {
    return {
      timmer: null,
    };
  },


  created() {
    this.timmer = setInterval(() => {
    }, 120000);
  },
  activated() {
    this.resize();
  },
  mounted() {
    setTimeout(() => {
      this.resize();
    }, 700);
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  destroyed() {
    clearInterval(this.timmer);
  },
  methods: {

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {

      }, 800);
    },

  },
};
</script>
